import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class UnitController extends BaseController {
  model = DataConst.MODELS.UNIT;
}

export default new UnitController();
